function navigation() {
    (function($) {
        $(function() {
            const body = document.querySelector("body");
            const $fullscreenNav = $(".menu-full-wrap");

            $(".main-menu--top, .main-menu--full").each(function() {
                const $labelLinks = $("> li > a", this);

                // these top level links should not go anywhere
                // removing href to disable links
                $labelLinks.removeAttr("href");
            });

            $fullscreenNav.on(
                "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend",
                function() {
                    if ($(this).hasClass("fadeIn")) {
                        $(this).removeClass("fadeIn");
                    }

                    if ($(this).hasClass("fadeOutDownBig")) {
                        $(this).removeClass("fadeOutDownBig animated");
                    }
                }
            );

            $(".menu-toggle").on("click touch", function() {
                if ($(body).hasClass("fullscreen-menu")) {
                    $fullscreenNav.addClass("animated fadeOutDownBig");
                } else {
                    $fullscreenNav.addClass("animated fadeIn");
                }

                $(".menu-toggle__inner", this).toggleClass("animate");
                $(body).toggleClass("fullscreen-menu");
                $(".main-navigation--top").toggleClass(
                    "main-navigation--toggled-on toggled-on"
                );
            });

            $(".close-menu-full").on("click touch", function() {
                $(".menu-toggle").click();
            });

            function initMainNavigation( container ) {

                var dropdownToggle = '<button class="dropdown-toggle" aria-expanded="false"><svg class="icon icon-angle-down" aria-hidden="true" role="img"> <use href="#icon-angle-down" xlink:href="#icon-angle-down"></use> </svg><span class="svg-fallback icon-angle-down"></span><span class="screen-reader-text">Expand child menu</span></button>';

            container.find( '.menu-item-has-children > a, .page_item_has_children > a' ).after( dropdownToggle );

            container.find( '.dropdown-toggle' ).on( 'click', function( e ) {
                var _this = $( this ),
                    screenReaderSpan = _this.find( '.screen-reader-text' );

                e.preventDefault();
                _this.toggleClass( 'toggled-on' );
                _this.next( '.children, .sub-menu' ).toggleClass( 'toggled-on' );

                _this.attr( 'aria-expanded', _this.attr( 'aria-expanded' ) === 'false' ? 'true' : 'false' );

                screenReaderSpan.text( screenReaderSpan.text() === twentyseventeenScreenReaderText.expand ? twentyseventeenScreenReaderText.collapse : twentyseventeenScreenReaderText.expand );
            });
               
            }

            initMainNavigation( $( '.main-navigation' ) );
        });
    })(jQuery);
}

export default navigation;



// WEBPACK FOOTER //
// ./src/js/partials/navigation.js